module.exports = __webpack_public_path__ + "img/1-start_v8e_front.4a60e974.png";